import { shareGame, viewport } from "@/constants"
import { Airdrop } from "@/components/icons"
import { LinkIcon } from "@heroicons/react/24/solid"
import { FaTwitter, FaFacebookF } from "react-icons/fa6"
import { BsChatFill } from "react-icons/bs"
import Game from "./Game"
import { ReactNode, useState } from "react"
import clsx from "clsx"
import { AnimatePresence, motion } from "framer-motion"

const containerVariants = {
  hidden: { opacity: 0, y: -10, scale: 0.95 },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
  },
  hide: {
    opacity: 0,
    y: -10,
    scale: 0.95,
  },
}

const item = {
  hidden: { opacity: 0 },
  show: { opacity: 1 },
}

const ShareButton = ({
  text,
  color,
  icon,
  hideOnMobile = false,
}: {
  text: string
  color: string
  icon: ReactNode
  hideOnMobile?: boolean
}) => (
  <motion.div
    variants={item}
    className={clsx(
      "flex-col items-center space-y-1.5",
      hideOnMobile ? "hidden sm:flex" : "flex"
    )}
  >
    <div
      className={clsx(
        "flex h-14 w-14 items-center justify-center rounded-xl",
        color
      )}
    >
      {icon}
    </div>
    <span className="text-xs leading-none font-medium text-gray-500">
      {text}
    </span>
  </motion.div>
)

const Share = () => {
  const [showMessages, setShowMessages] = useState(false)

  return (
    <div className="h-[328px] w-full max-w-[466px] space-y-4 select-none lg:max-w-none">
      <Game {...shareGame} showShareButton />

      <AnimatePresence>
        <motion.div
          key="buttons"
          initial="hidden"
          whileInView="show"
          exit="hide"
          variants={containerVariants}
          viewport={viewport}
          transition={{ staggerChildren: 0.2, delayChildren: 0.2 }}
          className="relative flex justify-between space-x-4 overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3 shadow-lg sm:px-6"
          onAnimationComplete={(type) => setShowMessages(type === "show")}
        >
          <ShareButton
            text="Copy link"
            color="bg-chessdrop-500"
            icon={<LinkIcon className="h-8 w-8 text-white" />}
          />
          <ShareButton
            text="Airdrop"
            color="bg-white border border-gray-200"
            icon={<Airdrop className="h-10 w-10 text-[#007AFE]" />}
          />
          <ShareButton
            text="Messages"
            color="bg-[#53d769]"
            icon={<BsChatFill className="h-9 w-9 text-white" />}
          />
          <ShareButton
            text="Twitter"
            color="bg-[#1DA1F2]"
            icon={<FaTwitter className="h-8 w-8 text-white" />}
          />
          <ShareButton
            text="Facebook"
            color="bg-[#4267B2]"
            icon={<FaFacebookF className="h-8 w-8 text-white" />}
            hideOnMobile
          />
        </motion.div>

        {showMessages && (
          <motion.div
            key="messages"
            initial="hidden"
            whileInView="show"
            exit="hide"
            variants={containerVariants}
            viewport={viewport}
            className="relative flex flex-col justify-between space-y-3 rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-lg sm:px-6"
            transition={{ delayChildren: 0.2, staggerChildren: 0.5 }}
          >
            <motion.div
              variants={item}
              className="self-end rounded-xl bg-[#147efb] px-3 py-2 text-sm font-medium text-white underline shadow"
            >
              https://chessdrop.com/games/1kn3...
            </motion.div>
            <motion.div
              variants={item}
              className="self-start rounded-xl bg-gray-200 px-3 py-2 text-sm font-medium text-gray-900 shadow"
            >
              Great game! Here’s what you could
              <br />
              improve:
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Share
